export const networking = {
  'QrBadge': 'QR odznak',
  'seeAll': 'Zobrazit vše',
  'newcommers': 'New Networkers',
  'checkThemOut': 'Podívejte se na ně!',
  'topicsToDiscuss': 'Témata k diskusi',
  'OneOnOneMeet': '1:1 setkání',
  'learnMoreNetworking': 'Zjistěte více o Networking Hubu',
  'scanQrCode': 'Naskenovat QR kód',
  'myBadge': 'Můj odznak',
  'scannedBadge': 'Naskenovaný odznak',
  'viewProfile': 'Zobrazit profil',
  'userRatingDetails': 'Detaily hodnocení uživatele',
  'networkingHub': 'Networking Hub',
  'totalScore': 'Celkové skóre:',
  'scoreComposedOf': 'Toto skóre je složeno z:',
  'message': 'Zpráva',
  'confirmationText': 'Jste si jisti? Toto nelze vrátit zpět.',

  'welcomeMessage': 'Vítejte v <strong>Networking Hub</strong>, kde se spojují lidé! Tady je návod, jak to funguje:',
  'connectingMadeSimpleTitle': 'Jednoduché spojení',
  'connectingMadeSimpleDescription': 'Networking Hub nabízí strukturované aktivity a úrovně, které vám pomohou efektivně se propojit:',

  'newcomersDescription':
    '<strong>Newcomers:</strong> Prozkoumejte profily nováčků, přidejte si zajímavé do krátkého seznamu a pošlete zprávy. Můžete se s nimi i osobně propojit.',
  'shortlistDescription': '<strong>Shortlist:</strong> Jakmile projevíte zájem o někoho, přidáte ho do svého krátkého seznamu.',
  'contactedConnectedDescription':
    '<strong>Contacted/Connected:</strong> Jakmile se s někým spojíte a dostanete odpověď, přesunou se do těchto kategorií.',
  'skipDescription': '<strong>Skip:</strong> Nezajímáte se? Jednoduše přeskočte profil a pokračujte!',

  'enhancedNetworkingActivitiesTitle': 'Vylepšené aktivity pro propojení',
  'enhancedNetworkingActivitiesDescription': 'Kromě přímých spojení, Hub obsahuje:',

  'topicsToDiscussDescription':
    '<strong>Topics to Discuss:</strong> Prozkoumejte témata, která vás zajímají, a spojte se s autory nebo účastníky. Připojte se k online diskusím nebo naplánujte skupinová setkání a ponořte se hlouběji do těchto témat.',
  'oneOnOneMeetingPlannerDescription':
    '<strong>1:1 Meeting Planner:</strong> Spravujte žádosti o setkání, sledujte naplánované schůzky a snadno si organizujte svůj rozvrh.',

  'gamificationTitle': 'Gamifikace pro zábavu a zapojení',
  'gamificationDescription':
    'Zvyšte svou aktivitu pomocí žebříčku, který sleduje vaše body a ukazuje nejaktivnější síťové uživatele. Takto můžete získat body:',

  'pointsSystem': {
    points1000ProfileComplete: '<strong>1 000 bodů:</strong> Dokončete svůj profil (včetně fotky).',
    points1000PushNotifications: '<strong>1 000 bodů:</strong> Povolit push notifikace.',
    points100SendMeetingRequest: '<strong>100 bodů:</strong> Pošlete žádost o 1:1 setkání.',
    points400GetAcceptedRequest: '<strong>400 bodů:</strong> Získejte přijetí vaší žádosti o 1:1 setkání.',
    points400AcceptRequest: '<strong>400 bodů:</strong> Přijměte žádost o 1:1 setkání.',
    points100DeclineRequest: '<strong>100 bodů:</strong> Odmítněte žádost o 1:1 setkání.',
    points400CreateDiscussion: '<strong>400 bodů:</strong> Vytvořte téma k diskusi.',
    points50LikeDiscussion: '<strong>50 bodů:</strong> Lajkněte téma k diskusi.',
    points200PostFirstComment: '<strong>200 bodů:</strong> Kdykoli zveřejníte první komentář k jinému tématu.',
    points100LikeOnTopic: '<strong>100 bodů:</strong> Získejte lajk na své téma.',
    points200UniqueCommenter: '<strong>200 bodů:</strong> Získejte unikátního komentátora u svého tématu.',
    points100LikeShortlistUser: '<strong>100 bodů:</strong> Lajkněte/zařaďte uživatele do krátkého seznamu.',
    points50SkipUser: '<strong>50 bodů:</strong> Přeskočte uživatele.',
    points200StartChat: '<strong>200 bodů:</strong> Začněte chat (kontaktováno).',
    points300GetChatResponse: '<strong>300 bodů:</strong> Získejte odpověď v chatu (připojeno).',
    points400RespondToChat: '<strong>400 bodů:</strong> Odpovězte na chatovou žádost (připojeno).',
    points500SpeedNetworking: '<strong>500 bodů:</strong> Za každé rychlé seznamování.'
  },

  'finalMessage':
    'Využijte Networking Hub na maximum, objevte nové příležitosti a získejte vyšší pozici na žebříčku, jak se propojujete a angažujete s podobně smýšlejícími profesionály!',

  'manageMeeting': 'Spravovat schůzku',
  'addToCalendar': 'Přidat do kalendáře',
  'cancel': 'Zrušit',
  'accept': 'Přijmout',
  'accept&addToCalendar': 'Přijmout a přidat do kalendáře',
  'editDetails': 'Upravit podrobnosti',
  'reject': 'Odmítnout',
  'delete': 'Smazat',
  'exportContact': 'Exportovat kontakt',
  'scheduleNewOneOnOne': 'Naplánovat nové 1:1',
  'initiatedBy': 'Zahájeno',
  'rejectedBy': 'Zamítnuto',
  'you': 'ty',
  'meetPassed': 'Schůzka proběhla',
  'meetInProgress': 'Probíhá',

  'myOneOnOne': 'Můj 1:1',

  'speed': {
    history: 'Historie',
    minutes: 'min.',
    users_available: 'dostupní',
    rules: 'Pravidla',
    activate: 'Aktivovat',
    matching: 'Párování...',
    start: 'Start',
    find_a_user: 'Najděte uživatele se stejným obrázkem',
    find_a_user_number: 'Najděte uživatele se stejným číslem',
    waiting: 'Čekání...',
    speaking_now: 'Právě mluví',
    networking_topics: 'Síťová témata',
    session_ended: 'Sezení skončilo',
    find_next_partner: 'Najít dalšího partnera',
    find_next_group: 'Najít další skupinu',
    partner_wasnt_ready: 'Partner nebyl připraven',
    partner_wasnt_ready_description: 'Zdá se, že partner nebyl připraven na diskusi. Najděme nového!',
    start_matching: 'Začít párování'
  }
}
